
interface IProps {
    pin: string;
    checkPin?: string;
    isCheckView?: boolean;
}   


const PinIndicator = ({pin, checkPin, isCheckView}: IProps) => {
    return <div className="pin-indicators">
         <div className="pin-indicators">
                    {[...Array(6)].map((_, index) => (
                        <div 
                            key={index} 
                            className={`pin-indicator ${index < (isCheckView ? (checkPin ?? '').length : pin.length) ? 'active' : ''}`}
                        ></div>
                    ))}
                </div>
    </div>
}

export default PinIndicator;